import { Record, List } from 'immutable';
import isEmpty from 'transmute/isEmpty';
import filter from 'transmute/filter';
import pipe from 'transmute/pipe';
import map from 'transmute/map';
import { LogEventMessageFieldDefinitionKeys } from 'automation-ui-log-events/records/LogEventMessage/LogEventMessageFieldDefinition';
import LogEventMessage, { LogEventMessageKeys } from 'automation-ui-log-events/records/LogEventMessage/LogEventMessage';
export const LogEventMessageConfigKeys = {
  FIELD_DEFINITIONS: 'fieldDefinitions'
};
const defaultProps = {
  [LogEventMessageConfigKeys.FIELD_DEFINITIONS]: List()
};
export default class LogEventMessageConfig extends Record(defaultProps, 'LogEventMessageConfig') {
  populate(...fieldDefinitions) {
    return this.set(LogEventMessageConfigKeys.FIELD_DEFINITIONS, List(fieldDefinitions));
  }
  getVisibleLogEventMessages(logEvent, objectTypeId) {
    let prevPathInConfig = undefined;
    const processDefinitions = pipe(map(definition => {
      const definitionConstructor = definition[LogEventMessageFieldDefinitionKeys.PATH_KEYS_CONSTRUCTOR];
      const baseLogEventMessage = new LogEventMessage(definitionConstructor && definitionConstructor(logEvent, objectTypeId, prevPathInConfig) || {});
      const logEventMessage = baseLogEventMessage.merge({
        [LogEventMessageKeys.FIELD_KEY]: definition[LogEventMessageFieldDefinitionKeys.FIELD_KEY],
        [LogEventMessageKeys.IS_PRIMARY_RISK_MESSAGE]: definition[LogEventMessageFieldDefinitionKeys.IS_PRIMARY_RISK_MESSAGE_FIELD],
        [LogEventMessageKeys.IS_SECONDARY_RISK_MESSAGE]: definition[LogEventMessageFieldDefinitionKeys.IS_SECONDARY_RISK_MESSAGE_FIELD]
      });
      prevPathInConfig = logEventMessage[LogEventMessageKeys.PATH];
      return logEventMessage;
    }), filter(message => !isEmpty(message[LogEventMessageKeys.PATH])));
    return processDefinitions(this[LogEventMessageConfigKeys.FIELD_DEFINITIONS]);
  }
}